import { render } from "./change-password.vue?vue&type=template&id=c5d13eac&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"

import "./change-password.vue?vue&type=style&index=0&id=c5d13eac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d13eac"]])

export default __exports__